import HttpResponse from "../../../../utils/http/http.response";

export enum ContractsValidCollectionResponseTaxiContractBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type ContractsValidCollectionResponseRailyContract = {
  allowChargeDuringRide: boolean;
  id: string;
  cargoCompanyId: string;
};

export type ContractsValidCollectionResponseTaxiContractTaxiCorporation = {
  id: string;
  displayName: string;
};

export type ContractsValidCollectionResponseTaxiContract = {
  allowChargeDuringRide: boolean;
  id: string;
  taxiCorporation: ContractsValidCollectionResponseTaxiContractTaxiCorporation;
  billingModel: ContractsValidCollectionResponseTaxiContractBillingModel;
};

export type ContractsValidCollectionResponseData = {
  railyContracts: ContractsValidCollectionResponseRailyContract[];
  taxiContracts: ContractsValidCollectionResponseTaxiContract[];
};

type ContractsValidCollectionResponse =
  HttpResponse<ContractsValidCollectionResponseData>;

export default ContractsValidCollectionResponse;
